var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4756 1.25195C6.40108 1.25195 1.47559 6.01856 1.47559 11.8971C1.47559 17.7757 6.40108 22.5423 12.4756 22.5423C18.5501 22.5423 23.4756 17.7757 23.4756 11.8971C23.4756 6.01856 18.5501 1.25195 12.4756 1.25195Z",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8018 10.2773H12.7148V16.9884",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0842 17.2188H15.3451",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4755 5.07031C12.1681 5.07031 11.8676 5.15853 11.6119 5.32382C11.3563 5.4891 11.1571 5.72403 11.0395 5.99888C10.9218 6.27374 10.891 6.57619 10.951 6.86798C11.011 7.15976 11.159 7.42779 11.3764 7.63816C11.5938 7.84852 11.8707 7.99178 12.1723 8.04982C12.4738 8.10786 12.7863 8.07808 13.0703 7.96423C13.3543 7.85038 13.5971 7.65758 13.7679 7.41021C13.9387 7.16285 14.0298 6.87202 14.0298 6.57452C14.0298 6.17558 13.8661 5.79298 13.5746 5.51088C13.2831 5.22879 12.8877 5.07031 12.4755 5.07031Z",
    fill: "#C2CFE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7b21c60387ce0c591a7a83a028722cab.svg";
export { ForwardRef as ReactComponent };